// src/features/simulators/mobile-desk/types/index.ts

import {
  SectionCode,
  JourneyEventCode,
  KeyDeliveryMethod,
  GuestType,
} from '@/features/simulators/shared/types/journey.types';

// Re-export shared types
export { SectionCode, JourneyEventCode, KeyDeliveryMethod, GuestType };

// Mobile desk specific constants
export const MOBILE_DESK_SECTIONS = [
  SectionCode.S,
  SectionCode.I,
  SectionCode.F,
  SectionCode.U,
  SectionCode.P,
  SectionCode.K,
] as const;

export const MOBILE_DESK_CHANNEL = 'AirLobby';

export const MOBILE_DESK_DEVICE_TYPE = 'Virtual';

/**
 * Document scan method for mobile desk
 */
export enum DocumentScanMethod {
  AUTOMATIC = 'Automatic',     // Automatic document scanner (OCR)
  MANUAL = 'Manual',          // Manual entry by receptionist
  PHOTO = 'Photo',            // Photo capture with mobile
}

/**
 * Configuration for mobile desk simulator
 */
export interface MobileDeskConfig {
  hotelId: string;
  deviceId: string;
  receptionistName: string;
  count: number;
  delayBetweenSteps: number;
  delayBetweenCheckIns: number;
  guestType: GuestType;                    // Changed from checkInType
  keyDeliveryMethod: KeyDeliveryMethod;    // Changed from ReceptionistKeyDeliveryMethod
  documentScanMethod: DocumentScanMethod;
  errorRate: number;
  reservationNumber?: string;              // Optional manual reservation number
  autoGenerateReservation?: boolean;       // Auto-generate or manual entry
}

/**
 * Statistics for mobile desk simulator
 */
export interface MobileDeskStats {
  totalCheckIns: number;
  successfulCheckIns: number;
  failedCheckIns: number;
  walkingCheckIns: number;
  reservationCheckIns: number;
  totalEvents: number;
  averageTime: number;
  
  // Payment
  paymentSuccesses: number;
  paymentErrors: number;
  
  // Keys
  keysDelivered: number;
  keyDeliveryErrors: number;
  digitalKeysDelivered: number;
  qrGenerated: number;
  physicalKeysDispensed: number;
  manualKeyDelivery: number;
  
  // Document scanning
  documentScanErrors: number;
  ocrScans: number;
  manualEntry: number;
  photoScans: number;
  
  startTime?: Date;
  endTime?: Date;
}

/**
 * Result of a single check-in session
 */
export interface MobileDeskResult {
  success: boolean;
  reservationNumber: string;
  duration: number;
  error?: string;
  keyDelivered: boolean;
}